// Helper function to deep clone objects
export const clone_deep = (obj) => JSON.parse(JSON.stringify(obj));

// Tab configuration
export const TABS = [
  { id: "team", label: "Team Members" },
  { id: "access", label: "Access Control" },
  { id: "roles", label: "Roles" }
];

// Template for new team member
export const NEW_MEMBER_TEMPLATE = {
  first_name: "",
  last_name: "",
  email: "",
  phone_number: "",
  role: "Analyst",
  message: ""
};

// Default team members data
export const TEAM_MEMBERS = [
  {
    id: 1,
    name: "John Dlamini",
    email: "john.dlamini@company.co.za",
    role: "Administrator",
    status: "active",
    last_active: "2 hours ago"
  },
  {
    id: 2,
    name: "Sarah Nkosi",
    email: "sarah.nkosi@company.co.za",
    role: "Manager",
    status: "active",
    last_active: "1 day ago"
  },
  {
    id: 3,
    name: "Thabo Molefe",
    email: "thabo.molefe@company.co.za",
    role: "Analyst",
    status: "active",
    last_active: "3 hours ago"
  },
  {
    id: 4,
    name: "Nomsa Mthembu",
    email: "nomsa.mthembu@company.co.za",
    role: "Analyst",
    status: "invited",
    last_active: "Never"
  }
];

// Access control areas
export const ACCESS_AREAS = [
  { id: "company_profile", name: "Company Profile" },
  { id: "dashboard", name: "Dashboard" },
  { id: "programmes", name: "Programmes" },
  { id: "verification", name: "Verification" },
  { id: "reports", name: "Reports" },
  { id: "settings", name: "Settings" }
];

// Default access permissions by role
export const ROLE_DEFAULTS = {
  Administrator: {
    company_profile: true,
    dashboard: true,
    programmes: true,
    verification: true,
    reports: true,
    settings: true
  },
  Manager: {
    company_profile: true,
    dashboard: true,
    programmes: true,
    verification: true,
    reports: true,
    settings: false
  },
  Analyst: {
    company_profile: false,
    dashboard: true,
    programmes: true,
    verification: true,
    reports: true,
    settings: false
  },
  Viewer: {
    company_profile: false,
    dashboard: true,
    programmes: false,
    verification: false,
    reports: true,
    settings: false
  }
};

// Member-specific access overrides
export const MEMBER_ACCESS_DEFAULTS = {
  1: { // John Dlamini (Administrator)
    company_profile: true,
    dashboard: true,
    programmes: true,
    verification: true,
    reports: true,
    settings: true
  },
  2: { // Sarah Nkosi (Manager)
    company_profile: true,
    dashboard: true,
    programmes: true,
    verification: true,
    reports: true,
    settings: false
  },
  3: { // Thabo Molefe (Analyst)
    company_profile: false,
    dashboard: true,
    programmes: true,
    verification: true,
    reports: true,
    settings: false
  },
  4: { // Nomsa Mthembu (Analyst)
    company_profile: false,
    dashboard: true,
    programmes: true,
    verification: true,
    reports: true,
    settings: false
  }
};

// Available roles data
export const ROLES = [
  {
    id: 1,
    name: "Administrator",
    short_name: "admin",
    description: "Full access to all features and settings",
    permissions: ["All Access", "Settings"],
    member_count: 1,
    color: "primary"
  },
  {
    id: 2,
    name: "Analyst",
    short_name: "analyst",
    description: "Can view and update programme data",
    permissions: ["Dashboard", "Programmes", "Reports"],
    member_count: 2,
    color: "secondary"
  },
  {
    id: 3,
    name: "Manager",
    short_name: "manager",
    description: "Can manage programmes and view reports",
    permissions: ["Company Profile", "Programmes", "Verification"],
    member_count: 1,
    color: "info"
  },
  {
    id: 4,
    name: "Viewer",
    short_name: "viewer",
    description: "Read-only access to assigned areas",
    permissions: ["Dashboard", "Reports"],
    member_count: 0,
    color: "light"
  }
];

// Template for new role
export const NEW_ROLE_TEMPLATE = {
  name: "",
  short_name: "",
  description: "",
  permissions: [],
  color: "light"
};

// Available permission options
export const AVAILABLE_PERMISSIONS = [
  "All Access", "Settings", "Dashboard", "Programmes", 
  "Reports", "Company Profile", "Verification"
];

// Color options for roles
export const ROLE_COLORS = [
  { value: "primary", label: "Blue", class: "bg-primary" },
  { value: "secondary", label: "Gray", class: "bg-secondary" },
  { value: "info", label: "Teal", class: "bg-info" },
  { value: "light", label: "Light", class: "bg-light text-dark" },
  { value: "success", label: "Green", class: "bg-success" },
  { value: "warning", label: "Yellow", class: "bg-warning text-dark" }
];
